import Model from "../Model";

class KpiEmployeeZone extends Model{

    buildUrl ({ param }) {
        return ['kpiemployee/getbyzone', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new KpiEmployeeZone;